import './capra/style';
import FormStructure from './capra/form_structure';

export default FormStructure;